import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {RNDatePicker} from "shared/controls/SingleInputs/RNDatePicker/RNDatePicker";
import {SpinnerButton} from "shared/controls/SpinnerButton";
import {library} from "@fortawesome/fontawesome-svg-core";
import {SearchableSelect} from "shared/controls/SingleInputs/SearchableSelect/SearchableSelect";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {ToastService} from "shared/utilities/services/ToastService";
import {Table} from "./Controls/Table";
import {ConfirmationDialog} from "shared/controls/Dialogs/premade/ConfirmationDialog/ConfirmationDialog";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {faFileExport} from "@fortawesome/free-solid-svg-icons/faFileExport";
import {faCloudDownloadAlt} from "@fortawesome/free-solid-svg-icons/faCloudDownloadAlt";
import {faCog} from "@fortawesome/free-solid-svg-icons/faCog";
import {ColumnDialog} from "./Dialog/ColumnDialog";
import {Dialog} from "shared/controls/Dialogs/core/Dialog";
import {SingleEntry} from "./Screens/SingleEntry";
import {SwitchContainer} from "shared/controls/animation/SwitchContainer";
import {AdvancedSearchControls, Condition} from "./Controls/SearchControl/AdvancedSearchControls";
declare let sfRedNaoCreateFormElementByName:any;
let fakeFileUploader=require('../../../../js/formBuilder/fakeFileUploader').fakeFileUploader;

library.add(faSearch);
export class EntriesApp extends React.Component<EntriesAppProps, EntriesAppState> {
    static defaultProps: Partial<EntriesAppProps> = {};

    public StartDate=0;
    public EndDate=0;
    public TempForm:string;
    public IsBusy:boolean;
    public Entries:any[];
    public SearchedForm:any;
    public SearchedStartDate:number=0;
    public SearchedEndDate:number=0;
    public SearchedAdvancedSearchIsShown:boolean;
    public SearchedConditions:Condition[];

    public currentEntryBeingEditted:any;
    public formElements:any[];
    public SelectedColumns:any[];
    public AdvancedSearchIsShown:boolean;
    public ViewRows:any[];
    public Conditions:Condition[];

    constructor(props: EntriesAppProps) {
        super(props);
        this.SearchedAdvancedSearchIsShown=false;
        this.Conditions=[];
        this.ViewRows=[];
        this.SelectedColumns=[];
        this.Entries=[];
        this.AdvancedSearchIsShown=false;
        this.SearchedForm='';
        this.TempForm='';
        this.state = {
            IsBusy:false,
            PageIndex:0,
            Size:50,
            RecordCount:0
        };
    }

    public render() {
        if(this.ViewRows.length>0)
            return <SingleEntry SelectedColumns={this.SelectedColumns} Entries={this.ViewRows} Form={SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.SearchedForm) as any} ClearView={()=>{this.ViewRows=[];this.forceUpdate();}}/>

        return (
            <div style={{margin:10}} className={'rednao'}>
                <fieldset style={{border:'1px solid #dfdfdf', padding:10}}>
                    <legend><FontAwesomeIcon icon={faSearch}/> Search Criteria</legend>
                    <RNDatePicker style={{display:'inline-block',marginRight:5}} Label={'Start Date'} Value={this.StartDate} onChange={x=>{this.StartDate=parseInt(x);this.forceUpdate();}} />
                    <RNDatePicker style={{display:'inline-block',marginRight:5}} Label={'End Date'} Value={this.EndDate} onChange={x=>{this.EndDate=parseInt(x);this.forceUpdate();}} />
                    <SearchableSelect Value={this.TempForm} onChange={x=>{this.TempForm=x;this.Conditions.push(new Condition()); this.forceUpdate();}} style={{display:'inline-block', marginRight:5,width:250}} Label={'Form'}>
                        {SmartFormsEntriesVar.Forms.map(x=>
                            <option key={x.FormId} value={x.FormId}>{x.FormName}</option>
                        )}
                    </SearchableSelect>
                    <SpinnerButton AddLabelMargin={true} IsBusy={this.state.IsBusy} Icon={'search'} OnClick={()=>this.ExecuteSearch()}> Search</SpinnerButton>

                    <div>
                        <SwitchContainer>
                            {this.AdvancedSearchIsShown?
                                <AdvancedSearchControls Conditions={this.Conditions} Form={this.TempForm} FormElements={(SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.TempForm) as any)} />:null
                            }
                        </SwitchContainer>
                        <a href={'#'} onClick={x=>{this.AdvancedSearchIsShown=!this.AdvancedSearchIsShown;this.forceUpdate();}}>{this.AdvancedSearchIsShown?'Hide Advanced Search':'Show Advanced Search'} </a>
                    </div>
                </fieldset>

                <div style={{margin:'10px 0'}}>
                    <button onClick={()=>this.Export()} disabled={this.Entries.length==0} className={'rnbtn rnbtn-primary'} ><FontAwesomeIcon icon={faCloudDownloadAlt}/> Export</button>
                    <button onClick={()=>this.ColumnConfig()} style={{marginLeft:5}} disabled={this.SearchedForm==''} className={'rnbtn rnbtn-info'} ><FontAwesomeIcon icon={faCog}/> Column Config</button>
                </div>
                <Table AvailablePageSize={[
                    {Label:"20 Records",Size:20},
                    {Label:"50 Records",Size:50},
                    {Label:"100 Records",Size:100},
                    {Label:"All Records",Size:0},
                ]} PageSizeChanged={x=>this.PageSizeChanged(x)} ViewRows={x=>this.ViewRow(x)} EditRow={x=>this.EdiRow(x)} PageChanged={x=>this.PageChanged(x)} DeleteRows={rows=>this.DeleteRows(rows)} PageSize={this.state.Size} Index={this.state.PageIndex} Form={SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.SearchedForm)} RowCount={this.state.RecordCount} FormElements={this.SelectedColumns.filter(x=>x._Selected)} Entries={this.Entries}/>
            </div>
        )
    }

    private ExecuteSearch(){
        if(this.TempForm=='') {
            ToastService.SendErrorMessage('Form is Required');
            return;
        }

        this.SearchedForm=this.TempForm;
        this.SearchedEndDate=this.EndDate;
        this.SearchedStartDate=this.StartDate;
        this.SearchedAdvancedSearchIsShown=this.AdvancedSearchIsShown;
        this.SearchedConditions=this.Conditions.slice();

        this.Search(0);
    }

    private async Search(index:number=0) {

        this.setState({
            IsBusy:true,
            RecordCount:0,
        });

        this.Entries=[];
        this.SelectedColumns=(SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.SearchedForm) as any).ElementOptions.slice(0);
        this.SelectedColumns.unshift({Id:'_Date',Label:'Date',ClassName:'rednaotextinput'});
        this.SelectedColumns.push({Id:'_UserName',Label:'Created By',ClassName:'rednaotextinput'});
        this.SelectedColumns.forEach(x=>x._Selected=true);
        this.SelectedColumns.push({Id:'_Ip',Label:'Ip',ClassName:'rednaotextinput'});


        let result=await WpAjaxPost.Post('rednao_smart_forms_entries_list',{
            StartDate:this.StartDate,
            EndDate:this.EndDate,Form:this.SearchedForm,
            PageIndex:index,
            PageSize:this.state.Size,
            Conditions:this.SearchedAdvancedSearchIsShown?this.SearchedConditions:[],
            nonce:SmartFormsEntriesVar.ListEntries
        });

        this.setState({IsBusy:false});
        if(result==null)
            return;

        this.Entries=JSON.parse(result.rows);

        for(let entry of this.Entries)
            entry.Selected=false;

        this.setState({
            RecordCount:result.count,
            PageIndex:index

        });
    }

    private DeleteRows(rows: any[]):void {
        DeleteDialog.Show('','Are you sure?',()=>{
            return new Promise(async resolve=>{
                let result=await WpAjaxPost.Post('rednao_smart_form_delete_entries',{Ids:rows.map(x=>x._EntryId)});
                if(result==true)
                {
                    for(let row of rows)
                    {
                        let entry=this.Entries.find(x=>x.entry_id==row._EntryId);
                        if(entry!=null)
                        {
                            this.Entries.splice(this.Entries.indexOf(entry),1);
                        }
                    }

                    this.forceUpdate();
                    resolve(true);
                }else{
                    resolve(false);
                }
            })
        });

    }

    private PageChanged(index: number) {
        this.Search(index);
    }

    private EdiRow(row: any) {
        this.updateEditContainer(row._EntryId);
        var $dialog=rnJQuery('#editDialog').RNDialog({
            ButtonClick:(action,button)=>{
                if(action=='accept')
                {
                    this.SaveEdition(row._EntryId);
                }
            },
            Width:'750px',
            Buttons:[
                {Label:'Cancel',Id:'dialogCancel',Style:'danger',Icon:'glyphicon glyphicon-remove',Action:'cancel'},
                {Label:'Submit',Id:'dialogAccept',Style:'success',Icon:'glyphicon glyphicon-ok',Action:'accept'}
            ]

        });

        let selectedForm:any=SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.SearchedForm);
        $dialog.parent().addClass('exptop');
        $dialog.find('modal-footer').css('clear','both').css('border','none');
        $dialog.find('.modal-content').css('max-height',rnJQuery(window).height()*0.7);
        $dialog.off('shown.bs.modal').on('shown.bs.modal',()=>{
            for(let formField of selectedForm.ElementOptions)
                if(formField.ClassName=='rednaosignature')
                    formField.ExecuteResize();
        });
        $dialog.RNDialog('Show');
    }

    private updateEditContainer(entryId: number) {
        SmartFormsModules.ContainerManager.ClearContainer(entryId);
        SmartFormsModules.ContainerManager.ClearContainer(0);
        var entry=null;
        this.currentEntryBeingEditted=entryId;
        for(var i=0;i<this.Entries.length;i++)
        {
            if(this.Entries[i].entry_id==entryId) {
                entry = this.Entries[i];
                break;
            }
        }


        var $container:any=rnJQuery('#editDialog');
        $container.empty();
        rnJQuery('#editDialog').RNDialog('Destroy');
        this.formElements=[];
        let selectedForm:any=SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.SearchedForm);
        for(var formOptions of selectedForm.ElementOptions)
        {
            var formElement:any;
            if(formOptions.ReadOnly!=null&&formOptions.ReadOnly=='y')
                formOptions.ReadOnly='n';
            if(formOptions.ClassName=="sfFileUpload")
                formElement=new fakeFileUploader(formOptions);
            else
                formElement=sfRedNaoCreateFormElementByName(formOptions.ClassName,formOptions);
            if(formElement.StoresInformation()||formElement.IsFieldContainer) {
                this.formElements.push(formElement);
            }
        }

        for(var i=0;i<this.formElements.length;i++)
            this.formElements[i].InitializeFieldLinking(this.formElements);

        for(var i=0;i<this.formElements.length;i++)
            this.formElements[i].AppendElementToContainer($container);

        for(var i=0;i<this.formElements.length;i++)
        {
            var value=entry.data[this.formElements[i].Id];
            this.formElements[i].SetData(value==undefined?{}:value);
        }

    }

    private SaveEdition(rowId:string) {
        var formValues:any={};

        for(var formElement of this.formElements)
        {
            var value=formElement.GetValueString();
            formValues[formElement.Id]=value;
        }
        var me=this;
        let selectedForm:any=SmartFormsEntriesVar.Forms.find(x=>x.FormId==this.SearchedForm);
        rnJQuery.ajax({
            type:'POST',
            url:ajaxurl,
            dataType:"json",
            data:{
                action:"rednao_smart_forms_edit_form_values",
                entryId:this.currentEntryBeingEditted,
                entryString:JSON.stringify(formValues),
                elementOptions:JSON.stringify(selectedForm.ElementOptions)
            },
            success:(result)=>{
                if(result.result) {
                    var currentEntry=null;
                    for(var entry of this.Entries)
                    {
                        if(entry.entry_id==this.currentEntryBeingEditted)
                            currentEntry=entry;
                    }
                    currentEntry.data=formValues;
                    rnJQuery('#editDialog').RNDialog('Hide');
                    this.forceUpdate();
                }
                else
                    alert('an error ocurred, please try again');
            },
            error:function(result) {
                alert('An error ocurred');
            }
        });
    }

    private async ColumnConfig() {
        await Dialog.Show(<ColumnDialog Column={this.SelectedColumns} />);
        this.forceUpdate();
    }

    private ViewRow(x: any[]) {
        this.ViewRows=x;
        this.forceUpdate();
    }

    private PageSizeChanged(x: number) {
        this.setState({
            Size:x
        },()=>this.Search(0))
    }

    private Export() {
        let url=ajaxurl;
        if(url.indexOf('?')==-1)
            url+='?';
        else
            url+='&';
        url+='action=rednao_smart_forms_export_entries&data='+
            JSON.stringify(
                {
                    Form:this.SearchedForm,
                    StartDate:this.SearchedStartDate,
                    EndDate:this.SearchedEndDate,
                    Conditions:this.SearchedAdvancedSearchIsShown?this.SearchedConditions:[],
                    Nonce:SmartFormsEntriesVar.Nonce
                });

        window.open(url);

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface EntriesAppProps {

}

interface EntriesAppState {
    IsBusy:boolean;
    PageIndex:number;
    Size:number;
    RecordCount:number;

}
declare let SmartFormsModules:any;
//#endregion "My Region"